import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/dialog/dialog'

import { cn } from '@/lib/utils'

export interface ServiceCenterExplanationDialogProps {
  isOpen: boolean
  close: VoidFunction
}

export const ServiceCenterExplanationDialog = ({ isOpen, close }: ServiceCenterExplanationDialogProps) => {
  const handleChangeOpen = (open: boolean) => {
    if (!open) {
      close()
      return
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleChangeOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Service Center Notice</DialogTitle>
          <DialogDescription className={cn('sr-only')}>
            This dialog provides guidance regarding the service center.
          </DialogDescription>
        </DialogHeader>

        <div className={cn('text-base font-normal text-foreground')}>
          Lawfully Pro shows only the service centers and field offices available for this category, based on the USCIS
          processing times website.
        </div>
      </DialogContent>
    </Dialog>
  )
}
